import { GlobalResponseObject } from '../../../common';
import { CompanyBiMessageModel } from './company-bi-message.model';

export class CompanyBiMessageResponse extends GlobalResponseObject {
    data?: CompanyBiMessageModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: CompanyBiMessageModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}